module.exports = __webpack_public_path__ + "img/qx2.ebec62e8.png";